const isDevelopment = process.env.NODE_ENV === 'development';

const DEV_DADATA_TOKEN = 'Token f7209c47838a1b72c77eb365d74a797eff4f2304';
const PROD_DADATA_TOKEN = 'Token f7209c47838a1b72c77eb365d74a797eff4f2304';

export const DADATA_TOKEN = isDevelopment ? DEV_DADATA_TOKEN : PROD_DADATA_TOKEN;
